import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AdventurePackSection.module.css';

const PRICE_ROWS = [
  { key: 'd1', price: '1500 THB' },
  { key: 'd2', price: '2800 THB' },
  { key: 'd3', price: '3900 THB' },
  { key: 'd5', price: '6000 THB' },
];

function AdventurePackSection() {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const cardCount = 5;

  const handleScroll = () => {
    if (!sliderRef.current) return;
    const { scrollLeft, clientWidth } = sliderRef.current;
    const idx = Math.round(scrollLeft / clientWidth);
    setActiveIndex(idx);
  };

  const goToCard = (idx) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollTo({
      left: sliderRef.current.clientWidth * idx,
      behavior: 'smooth',
    });
    setActiveIndex(idx);
  };

  return (
    <section id="adventure-pack" className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>{t('adventure.heading')}</h2>
        <p className={styles.subheading}>{t('adventure.subheading')}</p>
        <p className={styles.description}>{t('adventure.description')}</p>
        <div className={styles.heroImage}>
          <img src="/adventure-pack.png" alt={t('adventure.heading')} loading="lazy" />
        </div>

        <div
          ref={sliderRef}
          className={styles.slider}
          role="region"
          aria-label={t('adventure.includesTitle')}
          onScroll={handleScroll}
        >
          <article className={styles.card}>
            <h3>{t('adventure.includesTitle')}</h3>
            <div className={styles.includesRow}>
              <div>
                <h4>{t('adventure.kayakTitle')}</h4>
                <ul>
                  {[1, 2, 3].map((i) => (
                    <li key={`k${i}`}><span className={styles.bullet}>•</span>{t(`adventure.kayak${i}`)}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h4>{t('adventure.cameraTitle')}</h4>
                <ul>
                  {[1, 2, 3].map((i) => (
                    <li key={`c${i}`}><span className={styles.bullet}>•</span>{t(`adventure.camera${i}`)}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h4>{t('adventure.beachTitle')}</h4>
                <ul>
                  {[1, 2].map((i) => (
                    <li key={`b${i}`}><span className={styles.bullet}>•</span>{t(`adventure.beach${i}`)}</li>
                  ))}
                </ul>
              </div>
            </div>
          </article>

          <article className={styles.card}>
            <h3>{t('adventure.pricesTitle')}</h3>
            <p className={styles.popularLine}>{t('adventure.popularLine')}</p>
            <div className={styles.priceRows}>
              {PRICE_ROWS.map((row) => (
                <div key={row.key} className={styles.priceRow}>
                  <span>{t(`adventure.${row.key}`)}</span>
                  <span className={styles.priceValue}>
                    {row.price}
                  </span>
                </div>
              ))}
            </div>
          </article>
          <article className={styles.card}>
            <h3>{t('adventure.whyTitle')}</h3>
            <ul>
              {[1, 2, 3, 4].map((i) => (
                <li key={i}><span className={styles.check}>✓</span>{t(`adventure.why${i}`)}</li>
              ))}
            </ul>
          </article>

          <article className={styles.card}>
            <h3>{t('adventure.ideasTitle')}</h3>
            <ul>
              {[1, 2, 3, 4].map((i) => (
                <li key={i}><span className={styles.bullet}>•</span>{t(`adventure.idea${i}`)}</li>
              ))}
            </ul>
          </article>
          <article className={styles.card}>
            <h3>{t('adventure.termsTitle')}</h3>
            <ul>
              {[1, 2, 3].map((i) => (
                <li key={i}><span className={styles.bullet}>•</span>{t(`adventure.term${i}`)}</li>
              ))}
            </ul>
          </article>
        </div>
        <div className={styles.dots} aria-label="Slider pagination">
          {[...Array(cardCount)].map((_, idx) => (
            <button
              key={idx}
              type="button"
              className={`${styles.dot} ${activeIndex === idx ? styles.dotActive : ''}`}
              onClick={() => goToCard(idx)}
              aria-label={`Go to card ${idx + 1}`}
            />
          ))}
        </div>

          <a
            href="https://wa.me/66943672385"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
          >
            {t('adventure.bookNow')}
          </a>
      </div>
    </section>
  );
}

export default AdventurePackSection;
